import React from "react";
import { useGetOtherTopics } from "../../utils/useTopics";
import RecommendContentArea from "../../common/recommend-content/RecommendContentArea";
import RecommendContent from "../../common/RecommendContent";
import { SwiperSlide } from "swiper/react";

type Props = {
  emitId: string;
  typeName: string;
};
const OtherTopicsContainer: React.FC<Props> = ({ emitId, typeName }) => {
  const { topics } = useGetOtherTopics({ emit_id: emitId });

  return (
    <>
      {topics?.length ? (
        <RecommendContentArea
          title={`${typeName}のトピックス`}
          subTitle=""
          linkTo={{ pathname: "topics", search: `?topic_type=${typeName}` }}
          swiperSlides={
            <>
              {topics.map((t) => (
                <SwiperSlide key={t.id}>
                  <RecommendContent
                    id={t.id}
                    name={t.name}
                    start_date={t.start_date}
                    type={"topics"}
                    trackingLabel="TypeMatchTopics"
                    imgs={t.imgs}
                  />
                </SwiperSlide>
              ))}
            </>
          }
        />
      ) : null}
    </>
  );
};

export default OtherTopicsContainer;
